import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import httpHelper from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import { Method_TYPE } from 'utils/http-helper';

const DeploymentPointModal = ({ isModalOpen, setIsModalOpen, deploymentPoint, fetchDeploymentPoints }) => {

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    sector: '',
    reqCount: '',
  });
  const [sectorOptions, setSectorOptions] = useState([]);
  const [editId,setEditId] = useState('')

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (deploymentPoint?.length > 0 && sectorOptions.length > 0) {
      const selectedSector = sectorOptions.find(
        (sec) => sec.label === deploymentPoint[0]?.sector
      );

      setFormData({
        name: deploymentPoint[0]?.deploymentpoint,
        description: deploymentPoint[0]?.description,
        sector: selectedSector?.value || '', // store sectorId
        reqCount: deploymentPoint[0]?.requestCount,
      });

      setEditId(deploymentPoint[0]?.id)
    }
  }, [deploymentPoint, sectorOptions]);

  useEffect(() => {
    getSectorValue();
  }, []);

  const getSectorValue = async () => {
    try {
      const data = await httpHelper(URL_CONSTANTS.GET_SECOTR_VALUES, Method_TYPE.GET);

      // Correctly map the sector data to options
      setSectorOptions(
        data?.data?.map((sector) => ({
          value: sector?._id,
          label: sector?.name,
        })) || []
      );
    } catch (err) {
      console.error('Error fetching sector values:', err);
      setSectorOptions([]);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    setIsModalOpen(false)
    setFormData({
      name: '',
      description: '',
      sector: '',
      reqCount: '',
    });

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if(deploymentPoint?.length>0){
         await httpHelper(`${URL_CONSTANTS.EDIT_MANAGE_DEPLOYMENT_POINTS}/${editId}`, Method_TYPE.PUT, formData);
      setIsModalOpen(false)
      setFormData({
        name: '',
        description: '',
        sector: '',
        reqCount: '',
      });
      setEditId('')
      fetchDeploymentPoints()

      }else{
     await httpHelper(`${URL_CONSTANTS.ADD_MANAGE_DEPLOYMENT_POINTS}`, Method_TYPE.POST, formData);
      setIsModalOpen(false)
      setFormData({
        name: '',
        description: '',
        sector: '',
        reqCount: '',
      });
      fetchDeploymentPoints()
      }
     
    } catch (error) {
      console.error('Error saving deployment point:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="font-heading font-semibold text-lg text-foreground">
              {deploymentPoint?.length > 0 ? 'Edit Deployment Point' : 'Add Deployment Point'}
            </h2>
            <p className="text-sm text-muted-foreground">
              Configure deployment point requirements and details
            </p>
          </div>
          <Button variant="ghost" size="sm" onClick={handleCancel} iconName="X" />
        </div>
        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Deployment Point Name"
                name="name"
                type="text"
                value={formData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
                required
                placeholder="Enter deployment point name"
              />
              <Select
                label="Sector"
                options={sectorOptions}
                name="sector"
                value={formData.sector}
                onChange={(value) => handleInputChange('sector', value)} // value = sectorId
                required
              />
            </div>
            <Input
              label="Description"
              type="text"
              name="description"
              value={formData.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
              placeholder="Brief description of the deployment point"
            />
            <Input
              label="Request Count"
              type="number"
              name="reqCount"
              value={formData.reqCount}
              onChange={(e) => handleInputChange('reqCount', parseInt(e.target.value) || 0)}
              required
              min="0"
              placeholder="Number of members required"
            />
          </div>
          <div className="flex items-center justify-end space-x-3 pt-4 border-t border-border">
            <Button type="button" variant="outline" onClick={handleCancel} disabled={isLoading}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              loading={isLoading}
              iconName="Save"
              iconPosition="left"
            >
              {deploymentPoint?.length > 0 ? 'Update Point' : 'Create Point'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeploymentPointModal;
